/* Salty Paws - footer link pop-ups. Aug 26 2026.

   WHAT IT DOES
   The footer links below now open in a modal instead of navigating away, so a
   customer checking a policy from the cart does not lose the cart:

     /policies/shipping-policy   Shipping
     /policies/refund-policy     Returns and Refunds
     /policies/privacy-policy    Privacy Policy
     /policies/terms-of-service  Terms of Service
     /pages/about                About Salty Paws
     /pages/contact              Contact Us  (INFO ONLY - see the note below)

   It catches those links ANYWHERE on the site, not only in the footer. That
   includes the cart summary's "Taxes and shipping calculated at checkout" link
   and the policy links inside the Contact page FAQ.

   CONTACT US IS DELIBERATELY INFO-ONLY
   The pop-up shows the contact page's first section - email, phone, address and
   the FAQ - and NOT the message form. The form is a real Shopify contact form;
   a cloned copy could fail silently if Shopify's spam protection is bound to the
   original page, and that is not something we can test without sending real
   mail. The "Open the contact page to send a message" link at the bottom of the
   pop-up takes them to the working form.

   WHY IT IS BUILT THIS WAY
   Each page's text is fetched live from that page, so the real page stays the
   single source of truth. Edit a policy in Shopify admin, or the About page in
   the theme editor, and the pop-up updates itself. Nothing is duplicated here.

   FAILS SAFE
   If <dialog> is unsupported, the fetch fails, or the user cmd/ctrl/middle
   clicks, the link behaves exactly as it does today and navigates to the page.

   TO REVERT
   Delete the <script src="sp-policy-popup.js"> line from layout/theme.liquid
   (it sits inside the SP FIX Aug26 popup comment block). This file can stay.
*/
(function () {
  'use strict';

  /* path -> pop-up title. Add or remove a line here to change what pops up. */
  var TARGETS = {
    '/policies/shipping-policy': 'Shipping',
    '/policies/refund-policy': 'Returns & Refunds',
    '/policies/privacy-policy': 'Privacy Policy',
    '/policies/terms-of-service': 'Terms of Service',
    '/pages/about': 'About Salty Paws',
    '/pages/contact': 'Contact Us'
  };

  /* Overrides for the link at the bottom of the pop-up. */
  var FULL_LINK = {
    '/pages/contact': 'Open the contact page to send a message'
  };
  var FULL_LINK_DEFAULT = 'Open the full page';

  var STYLE_ID = 'sp-policy-popup-style';
  var CSS =
    /* margin:auto is required - this theme sets a bare `dialog { margin: 0; inset: 0 }`
       rule, which pins the modal to the top-left corner instead of centring it. */
    '.sp-pp{border:0;padding:0;margin:auto;max-width:640px;width:calc(100vw - 32px);max-height:82vh;' +
    'border-radius:12px;box-shadow:0 12px 40px rgba(0,0,0,.28);color:inherit;background:#fff}' +
    '.sp-pp::backdrop{background:rgba(0,0,0,.45)}' +
    '.sp-pp__head{display:flex;align-items:center;justify-content:space-between;gap:16px;' +
    'padding:18px 20px;border-bottom:1px solid rgba(0,0,0,.12);position:sticky;top:0;background:inherit;border-radius:12px 12px 0 0}' +
    '.sp-pp__title{margin:0;font-size:1.15rem;line-height:1.2}' +
    '.sp-pp__close{border:0;background:transparent;font-size:1.6rem;line-height:1;cursor:pointer;' +
    'min-width:44px;min-height:44px;color:inherit}' +
    '.sp-pp__body{padding:18px 20px 24px;overflow-y:auto;max-height:calc(82vh - 64px);' +
    'font-size:.95rem;line-height:1.55;-webkit-overflow-scrolling:touch}' +
    '.sp-pp__body p{margin:0 0 12px}' +
    '.sp-pp__body h2,.sp-pp__body h3{margin:20px 0 8px;font-size:1rem;line-height:1.3}' +
    '.sp-pp__body ul,.sp-pp__body ol{margin:0 0 12px;padding-left:20px}' +
    '.sp-pp__body li{margin:0 0 6px}' +
    '.sp-pp__body a{color:inherit;text-decoration:underline}' +
    '.sp-pp__body img{max-width:100%;height:auto}' +
    '.sp-pp__foot{padding:0 20px 20px}' +
    '.sp-pp__foot a{font-size:.85rem;opacity:.75;color:inherit}';

  var dialog = null;
  var cache = {};
  var prevOverflow = '';

  function supported() {
    return typeof window.HTMLDialogElement === 'function' &&
      typeof document.createElement('dialog').showModal === 'function';
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function build() {
    if (dialog) return dialog;
    injectStyle();
    dialog = document.createElement('dialog');
    dialog.className = 'sp-pp';
    dialog.innerHTML =
      '<div class="sp-pp__head">' +
      '<h2 class="sp-pp__title"></h2>' +
      '<button type="button" class="sp-pp__close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="sp-pp__body">Loading&hellip;</div>' +
      '<div class="sp-pp__foot"><a class="sp-pp__fulllink" href="/"></a></div>';

    dialog.querySelector('.sp-pp__close').addEventListener('click', function () {
      dialog.close();
    });

    /* Stop the page behind the modal from scrolling. Chrome lets the wheel and
       touch-drag reach the page through the backdrop, which reads as broken on
       a phone.
       DO NOT use the dialog 'close' event to undo this. This theme loads
       popover-polyfill.js and the 'close' event never fires on our dialog -
       tested live on the cart page 2026-08-26, the listener was silent on the
       X button, on Escape and on a direct .close() call. That left the page
       permanently unscrollable. The `open` ATTRIBUTE is added and removed
       correctly, so watch that instead. */
    new MutationObserver(function () {
      if (!dialog.hasAttribute('open')) {
        document.body.style.overflow = prevOverflow;
      }
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });

    /* Click on the backdrop (outside the panel) closes it. */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    document.body.appendChild(dialog);
    return dialog;
  }

  /* Pull the readable content out of the real page.
     Policies render into .shopify-policy__body. Theme pages render one or more
     sections; we take the section whose id ends in __main, which on the Contact
     page is the info + FAQ block and deliberately excludes the form section. */
  function load(path) {
    if (cache[path]) return Promise.resolve(cache[path]);
    return fetch(path, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('bad status ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node =
          doc.querySelector('.shopify-policy__body') ||
          doc.querySelector('main [id$="__main"]') ||
          doc.querySelector('main .rte') ||
          doc.querySelector('main');
        if (!node) throw new Error('content not found');
        node = node.cloneNode(true);
        /* The modal shows its own title, so drop the page's own H1. Scripts and
           iframes are stripped defensively; forms are stripped because a cloned
           Shopify form cannot be trusted to submit. */
        var drop = node.querySelectorAll('script, style, iframe, form, h1');
        for (var i = 0; i < drop.length; i++) drop[i].remove();
        /* Some pages repeat their own name as an H2 (the Contact page does).
           Drop it only when it is the FIRST heading and it matches the pop-up
           title exactly, so real headings are never touched. */
        var t = (TARGETS[path] || '').trim().toLowerCase();
        if (t) {
          var head = node.querySelector('h1, h2, h3');
          if (head && head.textContent.trim().toLowerCase() === t) head.remove();
        }
        cache[path] = node.innerHTML;
        return cache[path];
      });
  }

  function open(path, fallbackHref) {
    var d = build();
    var bodyEl = d.querySelector('.sp-pp__body');
    var titleEl = d.querySelector('.sp-pp__title');
    var fullEl = d.querySelector('.sp-pp__fulllink');

    titleEl.textContent = TARGETS[path] || 'Details';
    d.setAttribute('aria-label', titleEl.textContent);
    fullEl.setAttribute('href', path);
    fullEl.textContent = FULL_LINK[path] || FULL_LINK_DEFAULT;
    bodyEl.innerHTML = 'Loading&hellip;';

    /* Already open means this is a swap from a link inside the pop-up. */
    if (!d.hasAttribute('open')) {
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      d.showModal();
    }

    load(path)
      .then(function (html) {
        bodyEl.innerHTML = html;
        bodyEl.scrollTop = 0;
      })
      .catch(function () {
        /* Could not fetch - do not leave the customer stuck in an empty box. */
        d.close();
        window.location.href = fallbackHref || path;
      });
  }

  /* Returns the matching target path, or null. Same-origin only. */
  function targetOf(a) {
    if (!a || !a.getAttribute) return null;
    try {
      var u = new URL(a.href, window.location.origin);
      if (u.origin !== window.location.origin) return null;
      var p = u.pathname.replace(/\/+$/, '');
      return Object.prototype.hasOwnProperty.call(TARGETS, p) ? p : null;
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('click', function (e) {
    if (!supported()) return;
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    /* The "Open the full page" link at the bottom of the pop-up must navigate. */
    if (a.classList && a.classList.contains('sp-pp__fulllink')) return;
    if (a.target && a.target !== '_self') return;
    var path = targetOf(a);
    if (!path) return;
    /* A policy link INSIDE the pop-up swaps the pop-up's content rather than
       throwing the customer out to a page. */
    e.preventDefault();
    open(path, a.href);
  });
})();
